import { NgModule } from '@angular/core';
import { GoBackDirective } from './go-back.directive';
import { PhoneNumberValidatorDirective } from './phone-number-validator.directive';
import { DigitOnlyDirective } from './digit-only.directive';
import { RequiredValueDirective } from './required-value.directive';
import { NoSpaceValidationDirective } from './no-space-validation.directive';


const COMPONENTS_EXPORT = [GoBackDirective, PhoneNumberValidatorDirective,
  DigitOnlyDirective, RequiredValueDirective,
  NoSpaceValidationDirective];
const COMPONENTS_ENTRY = [];
const COMPONENTS = [...COMPONENTS_EXPORT, ...COMPONENTS_ENTRY];

const MODULES_EXPORT = [];
const MODULES = [...MODULES_EXPORT];

@NgModule({
  declarations: [...COMPONENTS],
  entryComponents: [...COMPONENTS_ENTRY],
  imports: [...MODULES],
  exports: [...MODULES_EXPORT, ...COMPONENTS_EXPORT],
})
export class DirectivesModule {
}
